module.exports = __webpack_public_path__ + "static/media/Sources@1x.24cf15a9.png";